<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Confirmação de Dados Pessoais</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in dataStudent.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0">
            {{ dataStudent.introduction }}
          </p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <fieldset class="fieldErrors" v-if="errors.count() > 0">
            <legend>Atenção aos erros do formulário:</legend>
            <ul>
              <li
                v-for="(error, index) in errors.all()"
                :key="index"
                class="alert"
              >
                {{ error }}
              </li>
            </ul>
          </fieldset>

          <p v-html="item.message"></p>
          <vs-button
            v-if="item.field == 'nome_aluno' && calculateAge() < '18'"
            icon="account_circle"
            style="width: 98.5%; margin: 10px 0.75% 15px 0.75%;"
            color="#ffa500"
            @click="changeName()"
          >
            Editar Nome
          </vs-button>
          <p v-if="item.field == 'nome_aluno'">
            <label>Nome Social</label>
            <vs-input
              name="nomesocial"
              v-model="personalData.NOMESOCIAL_ALUNO"
              :value="personalData.NOMESOCIAL_ALUNO"
            />
          </p>
          <p v-if="item.field == 'email_aluno'">
            <vs-input
              name="email"
              v-model="personalData.EMAIL_ALUNO"
              :value="personalData.EMAIL_ALUNO"
              v-validate="'required|email'"
              data-vv-as="E-mail do Estudante"
            />
          </p>

          <p
           v-if="item.field == 'nascimento-aluno'"
          > <i>({{ calculateAge() }} anos)</i>
          </p>

          <vs-button
            v-if="item.field == 'nascimento-aluno' && calculateAge() < '18'"
            icon="event"
            style="width: 98.5%; margin: 10px 0.75% 15px 0.75%;"
            color="#ffa500"
            @click="changeDateBirth()"
          >
            Editar Data de Nascimento
          </vs-button>

          <p v-if="item.field == 'naturalidade_aluno'">
            <label> Estado Natal: </label>
            <vs-select
              name="estadonatal"
              width="100%"
              placeholder="Selecione um Estado"
              autocomplete
              v-model="personalData.ESTADONATAL_ALUNO"
              :value="personalData.ESTADONATAL_ALUNO"
              v-on:input="changeProvinces($event)"
              v-validate="'required'"
              data-vv-as="Estado Natal do Estudante"
            >
              <vs-select-item
                v-for="(option, i) in states"
                :key="i"
                :value="option.CODIGO"
                :text="option.NOME"
              />
            </vs-select>
            <br />
            <label> Cidade Natal: </label>
            <vs-select
              name="cidadenatal"
              width="100%"
              placeholder="Selecione uma Cidade"
              autocomplete
              v-model="personalData.CODNATURALIDADE_ALUNO"
              :value="personalData.CODNATURALIDADE_ALUNO"
              v-on:input="getNameOfCity()"
              v-validate="'required'"
              data-vv-as="Cidade Natal do Estudante"
            >
              <vs-select-item
                v-for="(municipio, i) in cities"
                :key="i"
                :value="municipio.value.CODIGO"
                :text="municipio.title"
              />
            </vs-select>
          </p>

          <p v-if="item.field == 'endereco_aluno'">
            <label>CEP</label>
            <vs-input
              name="cep"
              v-if="item.field == 'endereco_aluno'"
              v-mask="'#####-###'"
              v-model="personalData.CEP_ALUNO"
              :value="personalData.CEP_ALUNO"
              @keyup.enter="getAddressByCEP()"
              class="qi-input"
              v-validate="'required|regex:^([0-9]{5}-[0-9]{3})$'"
              data-vv-as="CEP"
            />
            <vs-button
              icon="search"
              style="width: 100%;margin-top: 10px;"
              @click="getAddressByCEP()"
            >
              Buscar
            </vs-button>
          </p>

          <p style="margin-top: 80px !important;" v-if="item.field == 'endereco_aluno'">
            <label> Rua / Avenida</label>
            <vs-input
              v-model="personalData.NOMERUA_ALUNO"
              :value="personalData.NOMERUA_ALUNO"
              :danger="!personalData.NOMERUA_ALUNO.length > 0 || personalData.NOMERUA_ALUNO.length > 60"
              danger-text="O campo endereço não pode ser vazio ou ter mais que 60 caracteres!"
              name="NomeRua"
              v-validate="'required'"
              data-vv-as="Logradouro"

            /><br />
            <label> Número </label>
            <vs-input
              v-model="personalData.NUMERO_ALUNO"
              :value="personalData.NUMERO_ALUNO"
              name="Numero"
              v-validate="'required'"
              data-vv-as="Número"
            /><br />
            <label> Complemento (Se houver) </label>
            <vs-input
              v-model="personalData.COMPLEMENTO_ALUNO"
              :value="personalData.COMPLEMENTO_ALUNO"
              name="Complemento"
            /><br />
            <label> Bairro </label>
            <vs-input
              name="bairro"
              v-model="personalData.BAIRRO_ALUNO"
              v-validate="'required'"
              data-vv-as="Bairro"
            /><br />
          </p>

          <p v-if="item.field == 'endereco_aluno'">
            <label> Estado </label>
            <vs-select
              name="estado"
              width="100%"
              placeholder="Selecione um Estado"
              autocomplete
              v-model="personalData.ESTADO_ALUNO"
              :value="personalData.ESTADO_ALUNO"
              v-on:input="changeProvinces($event)"
              v-validate="'required'"
              data-vv-as="Estado"
            >
              <vs-select-item
                v-for="(option, i) in states"
                :key="i"
                :value="option.CODIGO"
                :text="option.NOME"
              />
            </vs-select>
            <br />
            <label> Cidade </label>
            <vs-select
              width="100%"
              name="cidade"
              placeholder="Selecione uma Cidade"
              autocomplete
              v-model="personalData.CIDADE_ALUNO"
              :value="personalData.CIDADE_ALUNO"
              v-validate="'required'"
              data-vv-as="Cidade"
            >
              <vs-select-item
                v-for="(municipio, i) in cities"
                :key="i"
                :value="municipio.value"
                :text="municipio.title"
              /> </vs-select>
          <p v-if="item.field == 'escolaridade_aluno'">
            <vs-select
              name="escolaridade"
              width="100%"
              v-model="personalData.ESCOLARIDADE_ALUNO"
              placeholder="Selecione um Nível de Escolaridade"
              v-validate="'required'"
              data-vv-as="Escolaridade"
            >
              <vs-select-item
                :key="index"
                :value="option.value"
                :text="option.text"
                v-for="(option, index) in dados.escolaridade"
              />
            </vs-select>
          </p>
          <p v-if="item.field == 'telefones_aluno'">
            <label> Telefone Principal: </label>
            <vs-input
              name="telefone1"
              v-mask="'(##) ####-#####'"
              v-model="personalData.TELEFONE1_ALUNO"
              :value="personalData.TELEFONE1_ALUNO"
              v-validate="'required'"
              data-vv-as="Telefone principal"
            /><br />
            <label> Telefone para Recados: </label>
            <vs-input
              name="telefone2"
              v-mask="'(##) ####-#####'"
              v-model="personalData.TELEFONE2_ALUNO"
              :value="personalData.TELEFONE2_ALUNO"
              v-validate="'required'"
              data-vv-as="Telefone para recados"
            />
          </p>
          <vs-button
            v-if="item.field == 'documentos_aluno' && calculateAge() < '18'"
            icon="fingerprint"
            style="width: 98.5%; margin: 10px 0.75% 15px 0.75%;"
            color="#ffa500"
            @click="changeCPF()"
          >
            Editar CPF
          </vs-button>
          <p v-if="item.field == 'documentos_aluno'">
            <label> Agora preciso que me informe o RG: </label>
            <vs-input
              name="rg"
              v-model="personalData.RG_ALUNO"
              :value="personalData.RG_ALUNO"
              data-vv-as="RG"
            />
            <br />
            <br /><label> Data de emissão do RG: </label>
            <vs-input
              name="dataexprg"
              type="date"
              v-model="personalData.DATAEMISSAO_RGALUNO"
              :value="personalData.DATAEMISSAO_RGALUNO"
              data-vv-as="Data de emissão do RG"
            /><br />
            Estado emissor do RG:
            <vs-select
              name="estadorg"
              width="100%"
              placeholder="Selecione o estado de emissão do RG"
              v-model="personalData.ESTADOEMISSOR_RGALUNO"
              :value="personalData.ESTADOEMISSOR_RGALUNO"
              data-vv-as="Estado emissor do RG"
            >
              <vs-select-item
                v-for="(option, i) in states"
                :key="i"
                :value="option.CODIGO"
                :text="option.NOME"
              />
            </vs-select>
            <br /><label> Órgão expeditor: </label>
            <vs-input
              name="orgaoemissor"
              v-model="personalData.ORGAOEMISSOR_RGALUNO"
              :value="personalData.ORGAOEMISSOR_RGALUNO"
              v-validate="'required'"
              data-vv-as="Órgão expeditor do RG"
            />
          </p>
          <p v-if="item.field == 'pai_mae'">
            <label> Qual o nome completo da mãe? </label>
            <vs-input
              v-model="personalData.MAE_ALUNO"
              :value="personalData.MAE_ALUNO"
              v-validate="'required'"
              data-vv-as="Nome da Mãe"
              name="nomemae"
            />
            <br />
            <label> E o nome do pai, caso conste no registro?  </label>
            <vs-input
              v-model="personalData.PAI_ALUNO"
              :value="personalData.PAI_ALUNO"
            />
          </p>
          <div>
            <vs-row>
              <vs-divider/>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="arrow_back"
                  style="width: 100%;"
                  @click="back(item, index)"
                  v-if="item.field !== 'nome_aluno'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%;"
                  color="#139B0E"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-popup
          title="Nome do Aluno"
          :active.sync="sendName"
        >
          <vs-row>
            <vs-card>
              <vs-col>
                <div>
                  <vs-input
                    name="nome"
                    v-model="formName"
                    placeholder="Digite o Nome do Aluno"
                  />
                  <vs-button
                    icon="check_circle"
                    :disabled="!formName"
                    style="width: 100%; margin-top: 10px;"
                    color="#139B0E"
                    @click="saveNewNameStudent(formName)"
                  >
                    Alterar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
        <vs-popup
          title="Data de Nascimento"
          :active.sync="sendDateBirth"
        >
          <vs-row>
            <vs-card>
              <vs-col>
                <div>
                  <legend>Selecione a Data de Nascimento</legend>
                  <fieldset style="border-radius: 8.5px; padding: 8.5px;">
                    <vs-input
                      name="datanascimento"
                      type="date"
                      v-model="formDateBirth"
                    />
                  </fieldset>
                  <vs-button
                    icon="check_circle"
                    :disabled="!formDateBirth"
                    style="width: 100%; margin-top: 10px;"
                    color="#139B0E"
                    @click="saveNewDateBirthStudent(formDateBirth)"
                  >
                    Alterar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
        <vs-popup
          title="CPF do Aluno"
          :active.sync="sendCPF"
        >
          <vs-row>
            <vs-card>
              <vs-col>
                <div>
                  <vs-input
                    name="cpf"
                    v-model="formCPF"
                    v-mask="'###########'"
                    placeholder="Digite o CPF do Aluno"
                  />
                  <vs-button
                    icon="check_circle"
                    :disabled="!formCPF || (formCPF && formCPF.length < 11)"
                    style="width: 100%; margin-top: 10px;"
                    color="#139B0E"
                    @click="saveNewCPFStudent(formCPF)"
                  >
                    Alterar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence/>
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel/>
        </vs-card>
      </section>
    </div>
  </div>
</template>
<script>
import AuditModel from "../model/Audit.js";
import PreRegistrationService from "../services/preRegistration.js";
import AuditService from "../services/audits.js";
import PersonService from "../services/person";
import {
  getStepsInformation,
  firstName,
  notifyError,
  notifySuccess
} from "../helpers/index.js";
import {formatDateToLocale} from "../helpers";
import ServiceAudit from "../services/mailing";
import { onlyUpdateDiscussion } from "../helpers/service";
import Divergence from "../components/Divergence.vue";
import ReasonsCancel from "../components/ReasonsCancel.vue";

export default {
  name: "AuditStep1A",
  components: {
    Divergence,
    ReasonsCancel,
  },
  data: () => ({
    sendName: false,
    formName: null,
    sendDateBirth: false,
    formDateBirth: null,
    sendCPF: false,
    formCPF: null,
    dados: {
      null: null,
      escolaridade: [
        { text: "Analfabeto", value: "1" },
        { text: "Até o 5º ano incompleto do ensino fundamental", value: "2" },
        { text: "5º ano completo do ensino fundamental", value: "3" },
        { text: "Do 6º ao 9º ano do ensino fundamental ", value: "4" },
        { text: "Ensino fundamental completo", value: "5" },
        { text: "Ensino médio incompleto", value: "6" },
        { text: "Ensino médio completo", value: "7" },
        { text: "Superior Incompleto", value: "8" },
        { text: "Superior Completo", value: "9" },
        { text: "Pós Grad. incompleto", value: "A" },
        { text: "Pós Grad. completo", value: "B" },
        { text: "Mestrado incompleto", value: "C" },
        { text: "Mestrado completo", value: "D" },
        { text: "Doutorado incompleto", value: "E" },
        { text: "Doutorado completo", value: "F" },
        { text: "Pós Dout.incompleto", value: "G" },
        { text: "Pós Dout.completo", value: "H" },
      ],
    },
    dataStudent: null,
    coligateId: null,
    preRegistrationId: null,
    cities: [],
    states: [],
    personalData: {
      SEXO: "",
      BAIRRO_ALUNO: "",
      CEP_ALUNO: "",
      GRAUINSTRUCAO: "",
      COLIGADA_ALUNO: "",
      CPF: "",
      EMAIL_ALUNO: "",
      ESTADONATAL_ALUNO: "",
      CIDADENATAL_ALUNO: "",
      CODNATURALIDADE_ALUNO: "",
      ESTADO_ALUNO: "",
      MAE_ALUNO: "",
      CIDADE_ALUNO: "",
      DTNASCIMENTO: "",
      NUMERO_ALUNO: "",
      COMPLEMENTO_ALUNO: "",
      NOMERUA_ALUNO: "",
      NOME_ALUNO: "",
      NOMESOCIAL_ALUNO: "",
      PAI_ALUNO: "",
      CARTIDENTIDADE: "",
      TELEFONE1_ALUNO: "",
      TELEFONE2_ALUNO: "",
      TIPOPESSOA_CLIENTE: "",
      TIPORUA_ALUNO: "",
      TIPO_CLIENTE: "",
      CODPESSOA_ALUNO: "",
      ORGAOEMISSOR_RGALUNO: "SSP",
      ESTADOEMISSOR_RGALUNO: "RS",
      DTEMISSAOIDENT: "",
      hasRG: false,
    },
    succesUpdateClient: false,
    newStudentData: null,
    error: null,
  }),
  created() {
    //montagem do objeto de confirmações financeiras
    this.dataStudent = new AuditModel().getItem("dataStudent");
    this.getStates();
    this.changeProvinces("RS");
    //puxar a pré que está salva na sessão e busca os dados da pré no endpoint
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;
    this.loadPre(preRegistrationId);

    this.$vs.loading();
    new AuditService()
      .getPersonalData(preRegistrationId)
      .then((res) => {
        Object.assign(this.personalData, res.data);

        if (this.personalData.RG_ALUNO != "") this.personalData.hasRG = true;

        if (this.personalData.ESTADO_ALUNO == "") {
          this.personalData.ESTADO_ALUNO = "RS";
        }

        this.$vs.loading.close();
        this.dataStudent = JSON.stringify(this.dataStudent);

        this.dataStudent = this.dataStudent.replaceAll(
          "@PRIMEIRONOME_CLIENTE",
          firstName(this.personalData.NOME_CLIENTE)
        );
        this.dataStudent = this.dataStudent.replaceAll(
          "@NOME_ALUNO",
          this.personalData.NOME_ALUNO
        );
        this.dataStudent = this.dataStudent.replace(
          "@NASCIMENTO_ALUNO",
          formatDateToLocale(this.personalData.NASCIMENTO_ALUNO)
        );
        this.dataStudent = this.dataStudent.replace(
          "@CPF_ALUNO",
          this.personalData.CPF_ALUNO
        );
        this.dataStudent = JSON.parse(this.dataStudent);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    loadPre(preRegistrationId) {
      this.$vs.loading();
      new PreRegistrationService()
        .getPreRegistration(1, preRegistrationId)
        .then((res) => {
          this.pre = res.data;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    changeName() {
      this.sendName = true;
      this.formName = null;
    },

    changeDateBirth() {
      this.sendDateBirth = true;
      this.formDateBirth = null;
    },

    changeCPF() {
      this.sendCPF = true;
      this.formCPF = null;
    },

    calculateAge() {
      const birthDate = new Date(this.personalData.NASCIMENTO_ALUNO);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    getNameOfCity() {
      if (this.personalData.CODNATURALIDADE_ALUNO != "") {
        let city = this.personalData.CODNATURALIDADE_ALUNO;
        const result = this.cities.find(
          (municipio) => municipio.value.CODIGO == city
        );
        console.log(this.cities);
        this.personalData.CIDADENATAL_ALUNO = result.title;
      }
    },

    getAddressByCEP() {
      this.personalData.NUMERO_ALUNO = "";
      this.personalData.COMPLEMENTO_ALUNO = "";
      this.personalData.BAIRRO_ALUNO = "";
      this.personalData.NOMERUA_ALUNO = "";
      this.$vs.loading();
      new AuditService()
        .getAddressByCEP(this.personalData.CEP_ALUNO)
        .then((res) => {
          this.adress = res.data;
          if (this.inputCep != this.personalData.CEP_ALUNO || !this.personalData.CEP_ALUNO) {
          this.personalData.NOMERUA_ALUNO = this.adress.LOGRADOURO;
          this.personalData.BAIRRO_ALUNO = this.adress.BAIRRO;
          this.personalData.ESTADO_ALUNO = this.adress.UF;
          this.personalData.CIDADE_ALUNO = this.adress.CIDADE;
          this.personalData.TIPORUA_ALUNO = this.address.CODTIPORUA;
          }
        })
        .catch((error) => {
          console.error("Error", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getStates() {
      new ServiceAudit()
        .getStates()
        .then((res) => {
          this.states = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeProvinces(state) {
      new ServiceAudit()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.cities = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
        });
    },

    async confirmAdvance(item, index) {
      item.visible = false;
      item.valid = true;
      if (index == this.dataStudent.itens.length - 1) {
        this.$validator.validate().then(async (valid) => {
          if (!valid) {
            notifyError(this, "Corrigir os erros apresentados.");
            item.visible = true;
            return;
          } else {
            if (
              this.personalData.CPF_ALUNO.replace(/\D/g, "") !=
              this.personalData.CPF_CLIENTE.replace(/\D/g, "")
            ) {
              await this.saveStudentData();
              this.$router.push("/audits/1B");
            } else {
              await this.saveStudentData();
              await this.saveClientData();

              if(this.personalData.EMANCIPADO == 'S') {
                this.$router.push("/audits/emancipated");
              } else {
                this.$router.push("/audits/2");
              }
            }
          }
        });
      } else {
        this.dataStudent.itens[index + 1].visible = true;
      }
    },
    back(item, index) {
      item.visible = false;
      item.valid = true;
      this.dataStudent.itens[index - 1].visible = true;
    },

    async saveNewNameStudent(name) {
      this.sendName = false;

      const personData = {
        CODPESSOA: this.personalData.isNew ? -1 : this.personalData.CODPESSOA_ALUNO,
        NOME: name,
        NOMESOCIAL: this.personalData.NOMESOCIAL_ALUNO,
        DTNASCIMENTO: this.personalData.NASCIMENTO_ALUNO,
        ESTADONATAL: this.personalData.ESTADONATAL_ALUNO,
        CODNATURALIDADE: this.personalData.CODNATURALIDADE_ALUNO,
        NATURALIDADE: this.personalData.CIDADENATAL_ALUNO,
        SEXO: this.personalData.SEXO_ALUNO,
        CPFCNPJ: this.personalData.CPF_ALUNO ? this.personalData.CPF_ALUNO.replace(/\D/g, "") : "",
        TELEFONE1: this.personalData.TELEFONE1_ALUNO.replace(/\D/g, ""),
        TELEFONE2: this.personalData.TELEFONE2_ALUNO.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_ALUNO,
        BAIRRO: this.personalData.BAIRRO_ALUNO,
        CIDADE: this.personalData.CIDADE_ALUNO ? this.personalData.CIDADE_ALUNO.NOME : "",
        CEP: this.personalData.CEP_ALUNO,
        CARTIDENTIDADE: this.personalData.RG_ALUNO,
        DTEMISSAOIDENT: this.personalData.DATAEMISSAO_RGALUNO ? this.personalData.DATAEMISSAO_RGALUNO : "",
        ORGEMISSORIDENT: "SSP",
        UFCARTIDENT: "RS",
        CODTIPORUA: this.personalData.TIPORUA_ALUNO,
        RUA: this.personalData.NOMERUA_ALUNO,
        NUMERO: this.personalData.NUMERO_ALUNO,
        COMPLEMENTO: this.personalData.COMPLEMENTO_ALUNO,
        ESTADO: this.personalData.ESTADO_ALUNO,
        GRAUINSTRUCAO: this.personalData.ESCOLARIDADE_ALUNO,
        isNew: this.personalData.isNew ? this.personalData.isNew : "",
      };

      this.$vs.loading();
      await new PersonService()
        .newPerson(personData)
        .then(({ data }) => {
          this.personalData.CODPESSOA = data;
          notifySuccess(this, "Nome do aluno alterado com sucesso!");

          onlyUpdateDiscussion(
            'Alterou o nome do aluno \n' +
            'DE: ' + this.personalData.NOME_ALUNO + '\n' +
            'PARA: ' + name,
            this.pre.CODCOLIGADA,
            this.pre.CODLOCAL,
            this.pre.CODATENDIMENTO
          );

          setTimeout(function() {
            location.reload(true);
          }, 500);
        })
        .catch((response) => {
          notifyError(
            this,
            "Erro ao tentar atualizar o nome do aluno: " + response.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async saveNewDateBirthStudent(date) {
      this.sendDateBirth = false;

      const personData = {
        CODPESSOA: this.personalData.isNew ? -1 : this.personalData.CODPESSOA_ALUNO,
        NOME: this.personalData.NOME_ALUNO,
        NOMESOCIAL: this.personalData.NOMESOCIAL_ALUNO,
        DTNASCIMENTO: date,
        ESTADONATAL: this.personalData.ESTADONATAL_ALUNO,
        CODNATURALIDADE: this.personalData.CODNATURALIDADE_ALUNO,
        NATURALIDADE: this.personalData.CIDADENATAL_ALUNO,
        SEXO: this.personalData.SEXO_ALUNO,
        CPFCNPJ: this.personalData.CPF_ALUNO ? this.personalData.CPF_ALUNO.replace(/\D/g, "") : "",
        TELEFONE1: this.personalData.TELEFONE1_ALUNO.replace(/\D/g, ""),
        TELEFONE2: this.personalData.TELEFONE2_ALUNO.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_ALUNO,
        BAIRRO: this.personalData.BAIRRO_ALUNO,
        CIDADE: this.personalData.CIDADE_ALUNO ? this.personalData.CIDADE_ALUNO.NOME : "",
        CEP: this.personalData.CEP_ALUNO,
        CARTIDENTIDADE: this.personalData.RG_ALUNO,
        DTEMISSAOIDENT: this.personalData.DATAEMISSAO_RGALUNO ? this.personalData.DATAEMISSAO_RGALUNO : "",
        ORGEMISSORIDENT: "SSP",
        UFCARTIDENT: "RS",
        CODTIPORUA: this.personalData.TIPORUA_ALUNO,
        RUA: this.personalData.NOMERUA_ALUNO,
        NUMERO: this.personalData.NUMERO_ALUNO,
        COMPLEMENTO: this.personalData.COMPLEMENTO_ALUNO,
        ESTADO: this.personalData.ESTADO_ALUNO,
        GRAUINSTRUCAO: this.personalData.ESCOLARIDADE_ALUNO,
        isNew: this.personalData.isNew ? this.personalData.isNew : "",
      };

      this.$vs.loading();
      await new PersonService()
        .newPerson(personData)
        .then(({ data }) => {
          this.personalData.CODPESSOA = data;
          notifySuccess(this, "Data de nascimento do aluno alterada com sucesso!");

          onlyUpdateDiscussion(
            'Alterou a data de nascimento do aluno \n' +
            'DE: ' + formatDateToLocale(this.personalData.NASCIMENTO_ALUNO) + '\n' +
            'PARA: ' + formatDateToLocale(date),
            this.pre.CODCOLIGADA,
            this.pre.CODLOCAL,
            this.pre.CODATENDIMENTO
          );

          setTimeout(function() {
            location.reload(true);
          }, 500);
        })
        .catch((response) => {
          notifyError(
            this,
            "Erro ao tentar atualizar a data de nascimento do aluno: " + response.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async saveNewCPFStudent(cpf) {
      this.sendCPF = false;

      const personData = {
        CODPESSOA: this.personalData.isNew ? -1 : this.personalData.CODPESSOA_ALUNO,
        NOME: this.personalData.NOME_ALUNO,
        NOMESOCIAL: this.personalData.NOMESOCIAL_ALUNO,
        DTNASCIMENTO: this.personalData.NASCIMENTO_ALUNO,
        ESTADONATAL: this.personalData.ESTADONATAL_ALUNO,
        CODNATURALIDADE: this.personalData.CODNATURALIDADE_ALUNO,
        NATURALIDADE: this.personalData.CIDADENATAL_ALUNO,
        SEXO: this.personalData.SEXO_ALUNO,
        CPFCNPJ: cpf,
        TELEFONE1: this.personalData.TELEFONE1_ALUNO.replace(/\D/g, ""),
        TELEFONE2: this.personalData.TELEFONE2_ALUNO.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_ALUNO,
        BAIRRO: this.personalData.BAIRRO_ALUNO,
        CIDADE: this.personalData.CIDADE_ALUNO ? this.personalData.CIDADE_ALUNO.NOME : "",
        CEP: this.personalData.CEP_ALUNO,
        CARTIDENTIDADE: this.personalData.RG_ALUNO,
        DTEMISSAOIDENT: this.personalData.DATAEMISSAO_RGALUNO ? this.personalData.DATAEMISSAO_RGALUNO : "",
        ORGEMISSORIDENT: "SSP",
        UFCARTIDENT: "RS",
        CODTIPORUA: this.personalData.TIPORUA_ALUNO,
        RUA: this.personalData.NOMERUA_ALUNO,
        NUMERO: this.personalData.NUMERO_ALUNO,
        COMPLEMENTO: this.personalData.COMPLEMENTO_ALUNO,
        ESTADO: this.personalData.ESTADO_ALUNO,
        GRAUINSTRUCAO: this.personalData.ESCOLARIDADE_ALUNO,
        isNew: this.personalData.isNew ? this.personalData.isNew : "",
      };

      this.$vs.loading();
      await new PersonService()
        .newPerson(personData)
        .then(({ data }) => {
          this.personalData.CODPESSOA = data;
          notifySuccess(this, "CPF do aluno alterado com sucesso!");

          onlyUpdateDiscussion(
            'Alterou o CPF do aluno \n' +
            'DE: ' + this.personalData.CPF_ALUNO + '\n' +
            'PARA: ' + cpf,
            this.pre.CODCOLIGADA,
            this.pre.CODLOCAL,
            this.pre.CODATENDIMENTO
          );

          setTimeout(function() {
            location.reload(true);
          }, 500);
        })
        .catch((response) => {
          notifyError(
            this,
            "Erro ao tentar atualizar o cpf do aluno: " + response.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async saveStudentData() {
      const personData = {
        CODPESSOA: this.personalData.isNew ? -1 : this.personalData.CODPESSOA_ALUNO,
        NOME: this.personalData.NOME_ALUNO,
        NOMESOCIAL: this.personalData.NOMESOCIAL_ALUNO,
        DTNASCIMENTO: this.personalData.NASCIMENTO_ALUNO,
        ESTADONATAL: this.personalData.ESTADONATAL_ALUNO,
        CODNATURALIDADE: this.personalData.CODNATURALIDADE_ALUNO,
        NATURALIDADE: this.personalData.CIDADENATAL_ALUNO,
        SEXO: this.personalData.SEXO_ALUNO,
        CPFCNPJ: this.personalData.CPF_ALUNO.replace(/\D/g, ""),
        TELEFONE1: this.personalData.TELEFONE1_ALUNO.replace(/\D/g, ""),
        TELEFONE2: this.personalData.TELEFONE2_ALUNO.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_ALUNO,
        BAIRRO: this.personalData.BAIRRO_ALUNO,
        CIDADE: this.personalData.CIDADE_ALUNO.NOME,
        CEP: this.personalData.CEP_ALUNO,
        CARTIDENTIDADE: this.personalData.RG_ALUNO,
        DTEMISSAOIDENT: this.personalData.DATAEMISSAO_RGALUNO,
        ORGEMISSORIDENT: "SSP",
        UFCARTIDENT: "RS",
        CODTIPORUA: this.personalData.TIPORUA_ALUNO,
        RUA: this.personalData.NOMERUA_ALUNO,
        NUMERO: this.personalData.NUMERO_ALUNO,
        COMPLEMENTO: this.personalData.COMPLEMENTO_ALUNO,
        ESTADO: this.personalData.ESTADO_ALUNO,
        GRAUINSTRUCAO: this.personalData.ESCOLARIDADE_ALUNO,
        isNew: this.personalData.isNew,
      };

      const studentData = {
        RA: this.personalData.RA_ALUNO,
        CODCOLCFO: this.personalData.COLIGADA_CLIENTE,
        CODCFO: this.personalData.CODIGO_CLIENTE,
        CODPESSOA: this.personalData.CODPESSOA_ALUNO,
        CODFILIAL: this.personalData.CODFILIAL,
        CODTIPOCURSO: this.personalData.CODTIPOCURSO,
        isNew: false,
        MAE: this.personalData.MAE_ALUNO ? this.personalData.MAE_ALUNO : '',
        PAI: this.personalData.PAI_ALUNO ? this.personalData.PAI_ALUNO : '',
      }

      await new PersonService()
        .newPerson(personData)
        .then(({ data }) => {
          this.personalData.CODPESSOA = data;
        })
        .catch((response) => {
          notifyError(
            this,
            "Erro ao tentar atualizar o aluno: " + response.error
          );
        });

      await new PersonService()
        .newStudentPerson(studentData)
        .then(() => {
          this.newStudentData = true;
        })
        .catch((response) => {
          notifyError(
            this,
            "Erro ao tentar atualizar o aluno: " + response.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async saveClientData (){
      this.succesUpdateClient = false;
      const clientData = {
        NOMEFANTASIA: this.personalData.NOMESOCIAL_ALUNO,
        NOME: this.personalData.NOME_CLIENTE,
        CGCCFO: this.personalData.CPF_ALUNO,
        TELEFONE: this.personalData.TELEFONE1_ALUNO.replace(/\D/g, ""),
        TELEX: this.personalData.TELEFONE2_ALUNO.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_ALUNO,
        PESSOAFISOUJUR: this.personalData.TIPOPESSOA_CLIENTE,
        DTNASCIMENTO: this.personalData.NASCIMENTO_ALUNO,
        CODCOLCFO: this.personalData.COLIGADA_CLIENTE,
        CODCFO: this.personalData.CODIGO_CLIENTE,
        BAIRRO: this.personalData.BAIRRO_ALUNO,
        CEP: this.personalData.CEP_ALUNO,
        NUMERO: this.personalData.NUMERO_ALUNO,
        COMPLEMENTO: this.personalData.COMPLEMENTO_ALUNO,
        CODMUNICIPIO: this.personalData.CIDADE_ALUNO.CODIGO,
        CODETD: this.personalData.ESTADO_ALUNO,
        TIPORUA: this.personalData.TIPORUA_ALUNO,
        RUA: this.personalData.NOMERUA_ALUNO,
        CIDENTIDADE: this.personalData.RG_ALUNO,
        EMANCIPADO: this.personalData.EMANCIPADO == 'S' ? 'S' : '',
        isNew: false,
        };

      await new PersonService()
        .newClientPerson(clientData)
        .then(() => {
          this.succesUpdateClient = true;
        })
        .catch((error) => {
          notifyError(
            this,
            "Erro ao tentar atualizar os dados do responsável: " + error.response.data.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });

    },
  },
};
</script>
<style scoped>
p {
  margin-top: 1em;
}
</style>
